import { render } from "./RightPaneLayout.vue?vue&type=template&id=a0a29666"
import script from "./RightPaneLayout.vue?vue&type=script&lang=js"
export * from "./RightPaneLayout.vue?vue&type=script&lang=js"

import "./RightPaneLayout.vue?vue&type=style&index=0&id=a0a29666&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__